import { useMemo } from "react";
import type { Reservation } from "@b2bportal/ground-api";
import { DateTimeFormatStyle, useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";

const DATE_FORMAT = DateTimeFormatStyle.ShortMonthDayShortWeekday;
const SHORT_TIME_FORMAT = DateTimeFormatStyle.ShortTime;
export const useCarReservationCard = (reservation: Reservation) => {
  const { formatDateTime } = useI18nContext();
  return useMemo(
    () => ({
      text: {
        title: reservation.supplier.name ?? "",
        location: reservation.pickUp.location.name,
        pickupDate: formatDateTime(
          dayjs(reservation.pickUp.dateTime).toDate(),
          DATE_FORMAT
        ),
        pickupTime: formatDateTime(
          dayjs(reservation.pickUp.dateTime).toDate(),
          SHORT_TIME_FORMAT
        ),
        dropOffDate: formatDateTime(
          dayjs(reservation.dropOff.dateTime).toDate(),
          DATE_FORMAT
        ),
        dropOffTime: formatDateTime(
          dayjs(reservation.dropOff.dateTime).toDate(),
          SHORT_TIME_FORMAT
        ),
        confirmation: reservation.reservationId,
      },
    }),
    [reservation]
  );
};
